import React, { Component } from 'react';
import { Link } from 'react-router';
import { Form, FormField, Input, CheckBox, Button, Row, Col, Text, Translate, Card, CardContent } from '$common';
import Layout from './layout';



export default class Login extends Component {
  render() {
    const { onSubmit } = this.props;

    return (
      <Layout
        title={Translate.get('signin_page_title')}
        type={'login'}
        valueProposition={
          <ul>
            <li>{Translate.get('signin_value_proposition_1')}</li>
            <li>{Translate.get('signin_value_proposition_2')}</li>
            <li>{Translate.get('signin_value_proposition_3')}</li>
          </ul>
        }
      >
        <Form onSubmit={onSubmit}>
          <FormField name="email" label={Translate.get('email')}>
            <Input type="email" forceOnChange/>
          </FormField>
          <FormField name="password" label={Translate.get('password')}>
            <Input type="password" forceOnChange/>
          </FormField>
          <Row>
            <Col md="1/2">
              <FormField name="remember" label={Translate.get('keep_me_logged_in')}>
                <CheckBox />
              </FormField>
            </Col>
            <Col md="1/2">
              <Text align="right">
                <Link to="recover">{Translate.get('forgot_password')}</Link>
              </Text>
            </Col>
          </Row>
          <Button type="success" submit block id="live-sign-in-button" size="micro">{Translate.get('sign_in')}</Button>
        </Form>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/login.js